const _excluded = ["link"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { componentsThemeMap } from '../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../constants.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import '../../ui/Div/index.js';
import '../../ui/Image/index.js';
import '../../ui/Link/index.js';
import { Text } from '../../ui/Text.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { Image } from '../../ui/Image/Image.js';
import { Link } from '../../ui/Link/Link.js';
function AssetContent({
  logoSrc,
  name,
  style
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    background = _componentsThemeMap$s.background,
    foreground = _componentsThemeMap$s.foreground,
    borderLine = _componentsThemeMap$s.borderLine;
  return /*#__PURE__*/jsxs(Div, {
    width: "max-content",
    height: 48,
    css: {
      'border-radius': 100
    },
    spacingHorizontal: 1.75,
    spacingVertical: 1.5,
    background: background,
    elevation: 1,
    borderColor: borderLine,
    children: [/*#__PURE__*/jsx(Image, {
      width: 24,
      alt: `${name} icon`,
      src: logoSrc || '',
      imageFit: "contain"
    }), /*#__PURE__*/jsx(Text, {
      variant: "body",
      as: "span",
      color: foreground,
      spacingStart: 0.5,
      children: name
    })]
  });
}
function HighlightAsset(_ref) {
  let link = _ref.link,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(AnalyticsProvider, {
    analyticsPrefix: ANALYTICS_KEY.HighlightAsset,
    children: link ? /*#__PURE__*/jsx(Link, {
      href: link || '',
      children: /*#__PURE__*/jsx(AssetContent, _objectSpread({}, props))
    }) : /*#__PURE__*/jsx(AssetContent, _objectSpread({}, props))
  });
}
export { HighlightAsset };
//# sourceMappingURL=HighlightAsset.js.map
